import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/catalog";
import { Logo } from "./Logo";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/lenis";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1D16] px-5 pb-10 pt-24 text-[#F5F0E8] sm:px-8">
    <div className="mx-auto max-w-[1400px]">
      <Reveal className="flex flex-col gap-10 border-b border-[#F5F0E8]/15 pb-16 lg:flex-row lg:items-end lg:justify-between">
        <h2 className="font-display text-6xl font-black uppercase leading-[0.88] tracking-tight sm:text-8xl">
          Order your <span className="font-serif-i normal-case font-normal text-[#D99B26]">POW BALL.</span>
        </h2>
        <button data-testid="footer-shop-button" onClick={() => scrollToId("shop")} className="btn-gold self-start lg:self-auto">Shop the balls</button>
      </Reveal>
      <div className="grid gap-10 py-12 sm:grid-cols-3">
        <Logo light />
        <div className="space-y-1 text-sm text-[#F5F0E8]/80">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#D99B26]">Contact</div>
          <div data-testid="footer-email">{CONTACT.email}</div>
        </div>
        <div className="space-y-1 text-sm text-[#F5F0E8]/80">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#D99B26]">Payment</div>
          <div>Bank transfer · Prices in AUD</div>
          <div>Postage Australia-wide</div>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-3 border-t border-[#F5F0E8]/15 pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-[#F5F0E8]/65 sm:flex-row">
        <span>© {new Date().getFullYear()} POW Polocrosse Balls · Family owned · Proudly made in Western Australia</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#F5F0E8]">Admin</Link>
      </div>
    </div>
  </footer>
);
